import { gql } from '@apollo/client';
import type { FullSubEvent } from '@fastnorth/timer-api';

export const GET_FULLY_POPULATED_SUB_EVENT = gql`
  query getFullyPopulatedSubEvent($eventUniqueCode: ID!, $subEventId: ID!) {
    getFullyPopulatedSubEvent(eventUniqueCode: $eventUniqueCode, subEventId: $subEventId)
      @rest(
        type: "FullSubEvent"
        path: "/v2/api/events/{args.eventUniqueCode}/sub-events/{args.subEventId}"
        method: "GET"
        endpoint: "bff"
      ) {
      id
      name
      settings
      isPublic
      isVirtualOpen
      listingSettings
      displayMessages
      resultsType
      resultsLastModifiedDate
      unstructuredData
      challengeSettings
      hasVideos
      columns
      segments
      track
    }
  }
`;

export type GetFullyPopulatedSubEventVariables = {
  eventUniqueCode: string;
  subEventId: string;
};

export type GetFullyPopulatedSubEventData = {
  getFullyPopulatedSubEvent: FullSubEvent;
};
